// extracted by mini-css-extract-plugin
export default {"root":"OWkpE5_h8tiNu6Q5hANT"};